/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Invitation_Start_FreshInputs */

const es_co2_signup_invitation_start_fresh = /** @type {(inputs: Signup_Invitation_Start_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear una cuenta nueva`)
};

/**

* @param {Signup_Invitation_Start_FreshInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_invitation_start_fresh = /** @type {((inputs?: Signup_Invitation_Start_FreshInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Invitation_Start_FreshInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_invitation_start_fresh(inputs)
});